import axios from 'axios';

const saveTeamDefaultContact = async (body: any) => {
  const { data } = await axios.request({
    url: `/team/default/contact`,
    method: 'post',
    data: body,
  });

  return data;
};

export default saveTeamDefaultContact;
